import { http } from '@/api/http'
import type { ReservationSendRequest } from '@/lib/pos-types'
import { normalizeReservationSendRequest, unwrapList, unwrapSingle } from '@/api/normalizers'

type ListParams = {
  status?: ReservationSendRequest['status']
  limit?: number
}

export const reservationSendRequestsApi = {
  list: async (params?: ListParams): Promise<ReservationSendRequest[]> => {
    const res = await http.get<unknown>('/reservation-send-requests', { params })
    return unwrapList(res.data).map(normalizeReservationSendRequest)
  },
  create: async (payload: { reservationId: string; orderId: string }): Promise<ReservationSendRequest> => {
    const res = await http.post<unknown>('/reservation-send-requests', {
      reservation_id: payload.reservationId,
      order_id: payload.orderId,
    })
    return normalizeReservationSendRequest(unwrapSingle(res.data))
  },
  approve: async (id: string): Promise<ReservationSendRequest> => {
    const res = await http.post<unknown>(`/reservation-send-requests/${encodeURIComponent(id)}/approve`)
    return normalizeReservationSendRequest(unwrapSingle(res.data))
  },
  reject: async (id: string): Promise<ReservationSendRequest> => {
    const res = await http.post<unknown>(`/reservation-send-requests/${encodeURIComponent(id)}/reject`)
    return normalizeReservationSendRequest(unwrapSingle(res.data))
  },
}

